import { HttpInterceptorFn, HttpParams } from '@angular/common/http';

export const trimInterceptor: HttpInterceptorFn = (req, next) => {
  let clonedReq = req;

  // Trim URL query params
  if (clonedReq.url.includes('?')) {
    const [baseUrl, queryParamsString] = clonedReq.url.split('?');
    const parsedParams = new URLSearchParams(queryParamsString);
    let urlModified = false;
    parsedParams.forEach((value, key) => {
      const trimmedValue = value.trim()
      if (value !== trimmedValue) {
        parsedParams.set(key, trimmedValue);
        urlModified = true;
      }
    });
    if (urlModified) {
      const newUrl = `${baseUrl}?${parsedParams.toString()}`;
      clonedReq = clonedReq.clone({ url: newUrl });
    }
  }
  // Trim HttpParams (if passed via options.params)
  if (clonedReq.params) {
    let paramsModified = false;
    let newParams = clonedReq.params;

    clonedReq.params.keys().forEach((key) => {
      const values = clonedReq.params.getAll(key);
      if (values) {
        const hasUntrimmed = values.some(val => typeof val === 'string' && val !== val.trim());
        if (hasUntrimmed) {
          paramsModified = true;
          newParams = newParams.delete(key);
          values.forEach(val => {
            const finalVal = typeof val === 'string' ? val.trim() : val;
            newParams = newParams.append(key, finalVal);
          });
        }
      }
    });

    if (paramsModified) {
      clonedReq = clonedReq.clone({ params: newParams });
    }
  }

  // Trim request body
  if (clonedReq.body && typeof clonedReq.body === 'object') {
    const trimmedBody = trimStrings(clonedReq.body);
    clonedReq = clonedReq.clone({
      body: trimmedBody,
    });
  }
  return next(clonedReq);
};

function trimStrings(body: any): any {
  // Trim strings
  if (typeof body === 'string') {
    return body.trim()
  }
  // Return primitive values
  if (body === null || typeof body !== 'object') {
    return body;
  }

  // Skip special object types
  if (
    body instanceof Date ||
    body instanceof Blob ||
    body instanceof ArrayBuffer ||
    body instanceof File ||
    body instanceof FormData ||
    body instanceof HttpParams
  ) {
    return body;
  }

  // Handle arrays
  if (Array.isArray(body)) {
    return body.map((item) => trimStrings(item));
  }

  // Handle objects
  const newBody: any = {};

  for (const key in body) {
    if (Object.prototype.hasOwnProperty.call(body, key)) {
      newBody[key] = trimStrings(body[key]);
    }
  }

  return newBody;
}
